import React from 'react';
import { Container, Spinner } from 'react-bootstrap';

const LedmodulePlaceholder = () => {

    return (
        <Container className="container-ledmodule-placeholder">
            <Spinner
                className="spinner-ledmodule-placeholder"
                as="span"
                animation="border"
                role="status"
                aria-hidden="true"
            />
        </Container>
    );
};

export default LedmodulePlaceholder;